var _title, _path;
var _excluded = ["svgRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgWyoming = function SvgWyoming(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 236.94,
    height: 196.9,
    viewBox: "0 0 236.94 196.9",
    ref: svgRef
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "wyoming")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M237.21,82.94l-2.93,49.61-8.59,85.95-5.28-.59L57.7,200.14,3.2,194.28l3.91-23.44L20.58,90.75,28,43.48,30.55,21.6,124.7,35.27,240.14,48Z",
    transform: "translate(-3.2 -21.6)"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWyoming, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/wyoming.1c3a1309.svg";
export { ForwardRef as ReactComponent };